import { createContext } from 'react'

export const ServiceWorkerContext = createContext({
  isUpdateAvailable: false,
  isUpdating: false,
  serviceWorkerVersion: null,
  updateServiceWorker: () => {},
  checkForServiceWorkerUpdate: () => {},
})
